import { render, staticRenderFns } from "./CustomModalRejectConfirm.vue?vue&type=template&id=56a5e38b&scoped=true&"
import script from "./CustomModalRejectConfirm.vue?vue&type=script&lang=js&"
export * from "./CustomModalRejectConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a5e38b",
  null
  
)

export default component.exports